import Editor from './Editor';
import Save from './Save';

const { registerBlockType } = wp.blocks;

registerBlockType('button-text/block', {
    title: 'Texto com Botão',
    description: 'Coloque Texto com Botão CTA',
    icon: 'align-wide',
    category: 'text',
    attributes: {},
    edit: props => <Editor {...props} />,
    save: props => <Save {...props} />
});
